/**
 * The Google permissions a Symphony calendar connection asks for.
 *
 * Google returns the UNION of every scope an account has already granted this OAuth client, so an
 * account that has consented before looks identical whatever is requested here. A shortened list only
 * shows up on a FIRST-time connect — as a grant missing a scope the assistant needs weeks later — which
 * is why the list is one shared value rather than whatever each surface happens to need.
 *
 * iOS (`SocialAuth.googleCalendarCode`), Android (`CalendarConnect.kt`) and the RN app
 * (`use-google-authenticator.ts`) each restate it in their own language because their SDKs take it at
 * compile time. Web reads it from here.
 */
export const GOOGLE_CALENDAR_CONNECT_SCOPES = ['openid', 'https://www.googleapis.com/auth/userinfo.email', 'https://www.googleapis.com/auth/userinfo.profile', 'https://www.googleapis.com/auth/calendar.events', 'https://www.googleapis.com/auth/calendar.readonly', 'https://www.googleapis.com/auth/contacts.readonly', 'https://www.googleapis.com/auth/contacts.other.readonly', 'https://www.googleapis.com/auth/admin.directory.resource.calendar.readonly'];

/**
 * The OAuth client a browser calendar connect authorizes against — the verified scheduling-assistant
 * client, whose consent screen reads "Symphony by Wix".
 *
 * It is the only one of our two Google clients that can serve a browser: `symphony.wix.com` is an
 * authorized JavaScript origin on it, while the wix-login client the native apps mint through has no
 * browser origin at all and is owned by Wix Identity.
 *
 * A refresh token is bound to the client that minted it, so the server's code exchange must use this
 * same client — it reads the matching id and secret from its own databag
 * (`scheduling-assistant-google-client-id` / `-secret`). Not a secret: a client id is public, and it is
 * already compiled into the native apps.
 */
export const SCHEDULING_ASSISTANT_GOOGLE_CLIENT_ID = '373512099748-lkm9uviab6odip0u5ud94c9tonj1tatf.apps.googleusercontent.com';
//# sourceMappingURL=google-calendar-connect.js.map